import { Factory } from 'rosie';

Factory.define('WidgetConfigParameter');

Factory.define('WidgetConfigParameterWithDefaults')
  .extend('WidgetConfigParameter')
  .attr('param', 'param-abcde')
  .attr('value', 'value-abcde');
